import Box from '@mui/material/Box';

const InnerLayout = (props) => {
  const boxStyles = {
    marginTop: {
      xs: 'calc(6vh)',
      sm: 'calc(6vh)',
      md: 'calc(4vh)',
      lg: 'calc(6vh)',
    },
    paddingTop: {
      xs: 'calc(6vh)',
      sm: 'calc(6vh)',
      md: 'calc(4vh)',
      lg: 'calc(6vh)',
    },
    paddingBottom: {
      xs: 'calc(6vh)',
      sm: 'calc(12vh)',
      md: 'calc(2vh)',
      lg: 'calc(15vh)',
    },
    marginLeft: {
      xs: 'calc(2vw)',
      sm: 'calc(2vw)',
      md: 'calc(4vw)',
      lg: 'calc(6vw)',
    },
    paddingLeft: {
      xs: 'calc(2vw)',
      sm: 'calc(2vw)',
      md: 'calc(4vw)',
      lg: 'calc(6vw)',
    },
    marginRight: {
      xs: 'calc(1vw)',
      sm: 'calc(2vw)',
      md: 'calc(2vw)',
      lg: 'calc(6vw)',
    },
    paddingRight: {
      xs: 'calc(2vw)',
      sm: 'calc(2vw)',
      md: 'calc(2vw)',
      lg: 'calc(6vw)',
    },
  };
  return <Box sx={boxStyles}> {props.children} </Box>;
};

export default InnerLayout;
